import Vue from 'vue';
import moment from 'moment';

const success = (context, data) => {
  if (data.rental.availability && data.rental.price && !data.rental.dayIncludeOverride) {
    context.bookingDetails.isAvailableBooking = 'available';
  } else {
    if (data.rental.dayIncludeOverride) {
      context.bookingDetails.isAvailableBooking = 'include-override';
      context.includeOverrideMsg = data.rental.dayIncludeOverrideMsg;
    } else {
      context.bookingDetails.isAvailableBooking = 'not-available';
    }
  }

  if (data.rental.price) {
    context.bookingDetails.price = Number(data.rental.price);
    context.bookingDetails.duration = moment(data.rental.endDate).diff(moment(data.rental.startDate), 'days');
    context.bookingDetails.pricePerNight =  parseFloat(context.bookingDetails.price / context.bookingDetails.duration).toFixed(2);
  }
  if (data.rental.city_taxes) {
    context.bookingDetails.cityTaxes = Number(data.rental.city_taxes);
  }
};

const failed = (context, error) => {
  // context.showToasterError(error);
};

export default (context, data, directReturn = false) => {
  return Vue.$http.post('check-booking-availability', data)
    .then(response => {
      if(directReturn) {
        return response.data;
      }else{
        if (response && response.status === 200) {
          success(context, response.data);
        } else {
          failed(context, response.data);
        }
      }
    }).catch(error => {
      if (error) {
        failed(context, error);
      }
    })
}



// WEBPACK FOOTER //
// ./src/app/services/booking/checkBookingAvailability.js